import axiosClient from ".";
class PoolAPI {
  static getPoolAmounts(pool) {
    return axiosClient.get(`/api/v1/currency/pool_amounts/${pool}`);
  }
}

export default PoolAPI;
